/**
 * インフルエンサーの年代（`20代` など）。
 *
 * `InfluencerDetailColumn` のローカル関数 `calculateAge` を共通化したもので、
 * 出力は同じ。年代の定義そのものを変える場合は、両方の表示が変わることになる。
 */

/** 10歳未満をまとめる下限 */
const MINIMUM_AGE_RANGE = 10;

/**
 * 誕生日から年代（10, 20, 30 …）を求める。
 *
 * - 年齢は **UTC の「年」の差**。その年の誕生日を迎えたかは見ない（実年齢と最大1歳ずれる）
 * - 10歳未満は `10` に丸める（`0` を返さない）
 * - 誕生日が無い（`null` / `undefined` / 空文字）… `null`
 * - `Date` が解釈できない文字列 … `NaN`
 *
 * @param birthday `Date` が解釈できる日付文字列（`YYYY-MM-DD` など）
 */
export const resolveInfluencerAgeRange = (birthday?: string | null): number | null => {
  if (!birthday) return null;
  const currentYear = new Date().getUTCFullYear();
  const birthYear = new Date(birthday).getUTCFullYear();
  const age = currentYear - birthYear;
  return age < MINIMUM_AGE_RANGE ? MINIMUM_AGE_RANGE : Math.floor(age / 10) * 10;
};

/**
 * 表示用の年代ラベル。
 *
 * - 誕生日あり … `20代`
 * - 誕生日なし … 空文字
 * - 解釈できない日付 … `NaN代`
 */
export const formatInfluencerAgeRangeLabel = (birthday?: string | null): string => {
  const ageRange = resolveInfluencerAgeRange(birthday);
  return ageRange === null ? "" : `${ageRange}代`;
};
